import { appendEvent } from './dom/eventRenderer';
import { appendMessage } from './dom/messageRenderer';
import { clearTypingIndicator, showTypingIndicator } from './dom/typingIndicator';

const CONTENT_TYPE = {
  PARTICIPANT_JOINED: 'application/vnd.amazonaws.connect.event.participant.joined',
  PARTICIPANT_LEFT: 'application/vnd.amazonaws.connect.event.participant.left',
  CHAT_ENDED: 'application/vnd.amazonaws.connect.event.chat.ended',
  TYPING: 'application/vnd.amazonaws.connect.event.typing'
};

const PARTICIPANT_ROLE = {
  CUSTOMER: 'CUSTOMER',
  AGENT: 'AGENT',
  SYSTEM: 'SYSTEM'
};

const _processAwsAttachment = (container, content) => {
  if (content.ParticipantRole === PARTICIPANT_ROLE.CUSTOMER) {
    // Customer attachments are added to DOM once they are initiated
  } else {
    appendEvent(container, 'An attachment was shared, but viewing attachments is not supported yet.');
  }
};

const _processAwsEvent = (container, content) => {
  if (content.ContentType === CONTENT_TYPE.PARTICIPANT_JOINED) {
    if (content.ParticipantRole === PARTICIPANT_ROLE.CUSTOMER) {
      appendEvent(container, 'You have joined the chat');
    } else if (content.ParticipantRole === PARTICIPANT_ROLE.AGENT) {
      appendEvent(container, `${content.DisplayName} has joined the chat`);
    }
  } else if (content.ContentType === CONTENT_TYPE.PARTICIPANT_LEFT) {
    appendEvent(container, `${content.DisplayName} has left the chat`);
  } else if (content.ContentType === CONTENT_TYPE.CHAT_ENDED) {
    clearTypingIndicator(container);
    appendEvent(container, 'The chat has ended');
  } else if (content.ContentType === CONTENT_TYPE.TYPING && content.ParticipantRole === PARTICIPANT_ROLE.AGENT) {
    showTypingIndicator(container, content.DisplayName);
  }
};

const _processAwsMessage = (container, content) => {
  clearTypingIndicator(container);

  if (content.ParticipantRole === PARTICIPANT_ROLE.SYSTEM) {
    appendEvent(container, content.Content);
  } else if (content.ParticipantRole === PARTICIPANT_ROLE.CUSTOMER) {
    // Customer messages are added to DOM once they are initiated
  } else if (content.ParticipantRole === PARTICIPANT_ROLE.AGENT) {
    appendMessage(container, 'agent', content.Content, content.DisplayName);
  }
};

export const processWebsocketContent = (container, content) => {
  if (content.Type === 'EVENT') {
    _processAwsEvent(container, content);
  } else if (content.Type === 'MESSAGE') {
    _processAwsMessage(container, content);
  } else if (content.Type === 'ATTACHMENT') {
    _processAwsAttachment(container, content);
  }
};
